import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { JobWithShare, SupabaseShareEntityViewEnum } from "@/lib/supabase/supabaseTypes";
import { Logger } from "@/lib/logger/Logger";

export const useRecentClientJobs = (clientId: string | undefined, limit: number = 5) => {
	const [jobs, setJobs] = useState<JobWithShare[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!clientId) {
			setJobs([]);
			return;
		}

		const fetchRecentJobs = async () => {
			setLoading(true);
			setError(null);

			try {
				const { data, error } = await supabase
					.from(SupabaseShareEntityViewEnum.JOBS_WITH_SHARES)
					.select("*")
					.eq("client_id", clientId)
					.order("created_at", { ascending: false })
					.limit(limit);

				if (error) {
					Logger.error("Error fetching recent client jobs: " + error.message);
					setError(error.message);
					setJobs([]);
				} else {
					setJobs(data || []);
				}
			} catch (err) {
				Logger.error("Error in useRecentClientJobs: " + err);
				setError("Failed to fetch recent jobs");
				setJobs([]);
			} finally {
				setLoading(false);
			}
		};

		fetchRecentJobs();
	}, [clientId, limit]);

	return { jobs, loading, error };
};